import { render, staticRenderFns } from "./DocumentRequests.vue?vue&type=template&id=98b6ffc2&scoped=true"
import script from "./DocumentRequests.vue?vue&type=script&lang=js"
export * from "./DocumentRequests.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequests.vue?vue&type=style&index=0&id=98b6ffc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6ffc2",
  null
  
)

export default component.exports